import _ from 'lodash'
import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { Container, Image, Menu, Segment, Tab } from 'semantic-ui-react'

import nav from '../../../../assets/images/angle-gray.png'

import { actions as reports } from '../../../../store/actions/reports'

class Modules extends Component {
    constructor (props) {
        super(props)
        this.MAX = 5
        this.STEP = 4
        this.state = {
            count: 0,
            start: -1,
            end: -1,
            index: -1
        }
        autoBind(this)
    }

    componentDidMount () {
        this.initializeIndexes();
    }

    initializeIndexes () {
        const count = this.props.reports.length
        var index = this.props.reports.findIndex(p => p.id === this.props.currentReport.id);
        if (index >= 0) {
            let start
            let end
            if (count <= this.MAX) {
                end = count - 1
                start = 0
            } else {
                const left = index
                const right = count - index - 1
                if (left < this.MAX) {
                    start = 0
                    end = index + this.MAX - left - 1
                } else if (right < this.MAX) {
                    end = count - 1
                    start = index - (this.MAX - right - 1)
                } else {
                    end = index + 2
                    start = index - 2
                }
            }
            this.setState({ start, end, index, count })
        } else {
            index = count - 1
            const end = count - 1
            const start = Math.max(0, end - this.MAX + 1)
            this.setState({ start, end, index, count })
        }
    }

    changeModule (index) {
        let start = this.state.start
        let end = this.state.end
        if (index < this.state.start || index > this.state.end) {
            const left = index
            const right = this.state.count - index - 1
            if (left < this.MAX / 2) {
                start = 0
                end = index + (this.MAX - left)
            } else if (right < this.MAX / 2) {
                start = index - (this.MAX - right)
                end = this.state.count - 1
            } else {
                start = index - 2
                end = index + 2
            }
        }
        this.setState({ start, end, index }, () => {
            this.props.setCurrentReport(this.props.reports[index])
        })
    }

    peekBack () {
        const n = Math.min(this.state.start, this.STEP)
        this.setState({ start: this.state.start - n, end: this.state.end - n })
    }

    peekFront () {
        const n = Math.min(this.state.count - this.state.end - 1, this.STEP)
        this.setState({ start: this.state.start + n, end: this.state.end + n })
    }

    render () {
        if (_.isEmpty(this.props.reports)) {
            return null
        }
        const reports = this.props.reports.slice(this.state.start, this.state.end + 1)
        let panes = []
        const previous = {
            menuItem: (
                <Menu.Item className='module-nav previous' index={0} disabled key='module-nav-prev'>
                    {
                        this.state.start > 0 && (
                            <Image centered className='previous' src={nav} onClick={(_e) => { this.peekBack() }}/>
                        )
                    }
                </Menu.Item>
            ),
            render: () => {
                return null
            }
        }
        const next = {
            className: 'module-nav',
            menuItem: (
                <Menu.Item className='module-nav next' index={this.MAX + 1} disabled key='module-nav-next'>
                    {
                        this.state.end < this.state.count - 1 && (
                            <Image centered className='next' src={nav} onClick={(_e) => { this.peekFront() }}/>
                        )
                    }
                </Menu.Item>
            ),
            render: () => {
                return null
            }
        }
        panes = panes.concat([previous])
        panes = panes.concat(reports.map((report, index) => {
            return {
                menuItem: (
                    <Menu.Item className='module-name' index={index} key={`report_${report.id}`}>
                        <span>REPORT {report.id}</span>
                    </Menu.Item>
                ),
                render: () => {
                    return null
                }
            }
        }))
        panes = panes.concat([next])
        return (
            <Container className='modules'>
                <Tab
                    menu={{ secondary: true, pointing: true }}
                    panes={panes}
                    activeIndex={this.state.index - this.state.start + 1}
                    onTabChange={
                        (_e, { activeIndex }) => {
                            if (activeIndex === this.MAX + 1) {
                                return
                            }
                            this.changeModule(this.state.start + activeIndex)
                        }
                    }
                />
                <Segment className='module-date'>
                    {
                        this.props.reports[this.state.index] ? this.props.reports[this.state.index].date : ''
                    }
                </Segment>
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentReport: state.reports.currentReport,
        reports: state.reports.reports
    }
}

const mapDispatchToProps = (dispatch) => {
    const _reports = bindActionCreators(reports, dispatch)
    return {
        setCurrentReport: _reports.setCurrentReport
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Modules))



// WEBPACK FOOTER //
// ./src/components/participant-feel-data-reports/common/modules/index.js